import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  SessionStatus,
  UpdateTransactionStatusRequestV1,
  UpdateTransactionStatusResponseV1,
} from '../models';
import { SessionServiceFactory } from '../factories';

@Injectable({
  providedIn: 'root',
})
export class SessionTransactionService {
  constructor(private sessionServiceFactory: SessionServiceFactory) {}

  updateTransactionStatus(
    tenantId: string,
    sessionId: string,
    status: string,
  ): Observable<UpdateTransactionStatusResponseV1> {
    const sessionStatus = status.toLowerCase().includes('success')
      ? SessionStatus.Success
      : SessionStatus.Active;

    const updateTransactionStatusRequest: UpdateTransactionStatusRequestV1 = {
      status: SessionStatus[sessionStatus],
    };

    return this.sessionServiceFactory
      .create()
      .updateTransactionStatusV1(
        tenantId,
        sessionId,
        updateTransactionStatusRequest,
      )
      .pipe(
        map(
          (
            updateTransactionStatusResponse: UpdateTransactionStatusResponseV1,
          ) => {
            if (updateTransactionStatusResponse == null) {
              return {};
            }

            return updateTransactionStatusResponse;
          },
        ),
      );
  }
}
